import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconKeyhole2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="keyhole-2, lock, unlock"><path d="M12 2C15.866 2 19 5.13401 19 9C19 11.5125 17.675 13.7129 15.6895 14.9473L16.834 18.3809C17.4272 20.1613 16.1022 21.9997 14.2256 22H9.77441C7.89776 21.9997 6.57284 20.1613 7.16602 18.3809L8.30957 14.9473C6.32437 13.7129 5 11.5122 5 9C5 5.13401 8.13401 2 12 2Z" fill="currentColor"/></CentralIconBase>;
};

export default IconKeyhole2;
